export const dbPanels = {
  images: {
    subtitle: `Carica, riordina e imposta la foto principale di ogni unità mostrata nel tuo motore di prenotazione.`,
  },

  amenities: {
    searchPlaceholder: `Cerca servizio…`,
    selectedCount: `{count} servizio selezionato | {count} servizi selezionati`,
    noResults: `Nessun risultato per "{query}".`,
    // Fotos por comodidad: lo que el Agente IA le enseña al huésped.
    photos: {
      explain: `L'agente le mostrerà all'ospite che chiede di questa dotazione.`,
      dropTitle: `Trascina qui le foto`,
      addPhotos: `Aggiungi foto`,
      dropHint: `JPG, PNG, WebP o HEIC · fino a {mb} MB ciascuna`,
      dropActive: `Rilascia per caricare`,
      uploading: `Caricamento… {progress}%`,
      uploaded: `{count} foto aggiunta | {count} foto aggiunte`,
      counter: `{count} foto | {count} foto`,
      remaining: `Puoi aggiungere ancora {count} foto | Puoi aggiungere ancora {count} foto`,
      full: `Hai raggiunto il massimo di {max} foto`,
      tooMany: `Per ogni dotazione entrano solo {max} foto.`,
      tooHeavy: `«{name}» supera {mb} MB. Riducila prima di caricarla.`,
      notImage: `«{name}» non è un'immagine.`,
      uploadError: `Non è stato possibile caricare le foto.`,
      removeAria: `Rimuovi questa foto`,
      deleteTitle: `Rimuovere questa foto?`,
      deleteBody: `L'agente non la mostrerà più quando chiederanno di «{amenity}». Non si può annullare.`,
      deleteCancel: `Annulla`,
      deleteConfirm: `Rimuovi foto`,
      deleted: `Foto rimossa`,
      deleteError: `Non è stato possibile rimuovere la foto.`,
      // Orden: el agente solo manda las primeras, por eso se puede arrastrar.
      orderHint: `L'agente mostra le prime {count}. Trascina dalla maniglia per cambiare l'ordine.`,
      dragTitle: `Trascina per ordinare`,
      reordering: `Salvataggio dell'ordine…`,
      orderSaved: `Ordine salvato`,
      orderError: `Non è stato possibile salvare l'ordine.`,
      willSend: `L'agente invierà questa foto`,
      wontSend: `L'agente non arriva a inviare questa foto`,
      someFailed: `Non è stato possibile elaborare: {names}`,
    },
  },

  occupancy: {
    question: `Quale adeguamento vuoi applicare?`,
    questionRoom: `Quale adeguamento vuoi applicare a questa camera?`,
    modeNone: `Nessuno`,
    modeReduction: `Riduzione`,
    modeSurcharge: `Supplemento`,
    baseOccupancy: `Occupazione base`,
    baseHint: `ospiti (il prezzo standard)`,
    thOccupancy: `Occupazione`,
    thRule: `Regola`,
    thValue: `Valore`,
    thActive: `Attiva`,
    guestsCount: `{count} ospite | {count} ospiti`,
    ruleReductionPct: `Riduzione %`,
    ruleReductionFixed: `Riduzione {currency}`,
    reductionInfo: `Per un numero di ospiti inferiore all’occupazione base, questa riduzione si applica al prezzo dell’alloggio.`,
    priceIncludes: `Il prezzo include`,
    guestsCapacity: `ospite (capacità camera) | ospiti (capacità camera)`,
    maxExtraGuests: `Max ospiti extra`,
    chargePerExtraGuest: `Supplemento per ospite extra`,
    chargeFixed: `{currency} fisso`,
    perNight: `per notte`,
    surchargeInfo: `Ogni ospite oltre la capacità inclusa paga questo supplemento per notte.`,
    noneRoom: `Questa camera non ha adeguamenti per occupazione: lo stesso prezzo per qualsiasi numero di ospiti (entro la capacità).`,
    noneBooking: `Questa prenotazione non ha adeguamenti per occupazione: lo stesso prezzo per qualsiasi numero di ospiti (entro la capacità).`,
  },

  share: {
    title: `Condividi (Hotel)`,
    desc: `Questo link è specifico per questo hotel. Condividilo tramite WhatsApp o aprilo come visitatore.`,
    linkLabel: `Link di prenotazione hotel`,
    linkHint: `Usalo nella tua bio, nelle campagne o nei messaggi automatici.`,
    viewAsVisitor: `Visualizza come visitatore`,
    tip: `Suggerimento: puoi inviare questo link con il tuo messaggio di conferma prenotazione.`,
    noLinkCopy: `Nessun link da copiare.`,
    copied: `Link copiato.`,
    copyError: `Impossibile copiare il link.`,
    noLinkShare: `Nessun link da condividere.`,
    whatsappMsg: `Ciao 👋 Ecco il link per prenotare in questo hotel: {link}`,
    noLinkOpen: `Nessun link da aprire.`,
  },

  unitServices: {
    title: `Dotazioni e comfort`,
    subPrefix: `Servizi per`,
    thisRoom: `questa camera`,
    subInfo: `Ogni tipo di camera ha i propri; la prenotazione diretta e l’Agente IA usano quelli della camera assegnata all’ospite.`,
    loading: `Caricamento servizi…`,
    loadError: `Impossibile caricare i servizi di questa camera.`,
    retry: `Riprova`,
    saving: `Salvataggio…`,
    saved: `Salvato`,
    autosaveHint: `Le modifiche si salvano automaticamente quando selezioni o deselezioni.`,
  },

  welcome: {
    tag: `Motore di prenotazione diretta`,
    titleA: `Ottieni prenotazioni`,
    titleHighlight: `senza commissioni`,
    sub: `Il tuo motore di prenotazione per ogni struttura: condividi un link, l’ospite prenota e paga direttamente. Nessun intermediario, nessuna commissione OTA.`,
    howItWorks: `Come funziona`,
    benefits: `Vantaggi`,
    step1Title: `Condividi il tuo link`,
    step1Text: `Ogni struttura ha il proprio link. Pubblicalo sul tuo sito web, sui social o su WhatsApp; anche l’agente IA lo invia ai potenziali clienti.`,
    step2Title: `L’ospite prenota`,
    step2Text: `Sceglie le date e paga nel tuo motore. La prenotazione arriva direttamente nel tuo calendario, senza commissioni OTA.`,
    step3Title: `Ricevi il pagamento direttamente`,
    step3Text: `Ricevi i pagamenti senza intermediari e aggiungi promozioni, addebiti e servizi extra a ogni soggiorno.`,
    ctaStart: `Inizia la configurazione`,
    ctaPromotions: `Vedi le promozioni globali`,
    perk1Title: `Zero commissioni OTA`,
    perk1Text: `Trattieni il 100% di ogni prenotazione diretta.`,
    perk2Title: `Pagamento e conferma immediati`,
    perk2Text: `L’ospite paga e la prenotazione si conferma automaticamente.`,
    perk3Title: `Promozioni e addebiti extra`,
    perk3Text: `Sconti sul soggiorno, servizi e i tuoi addebiti.`,
    perk4Title: `Un link per ogni struttura`,
    perk4Text: `Ogni alloggio con il proprio motore e la propria disponibilità.`,
  },

  unitsList: {
    title: `Unità disponibili`,
    subtitle: `Abilita le unità che vuoi mostrare nel tuo motore di prenotazione.`,
    loading: `Caricamento…`,
    sectionUnits: `Unità`,
    colUnit: `Unità`,
    colCap: `Cap.`,
    colActive: `Attiva`,
    noUnits: `Nessuna unità configurata.`,
    active: `Attiva`,
    inactive: `Inattiva`,
    noticePrefix: `Abilita le prenotazioni dirette da`,
    noticeGlobalConfig: `Impostazioni globali`,
    noticeSuffix: `per gestire le unità.`,
    sectionLink: `Link del singolo appartamento`,
    linkCardTitle: `Link filtrato per questo appartamento`,
    linkCardDesc: `Apre lo stesso motore di prenotazione generale, ma mostrando direttamente questo appartamento.`,
    viewAsVisitor: `Visualizza come visitatore`,
    unitUpdated: `Unità aggiornata.`,
    updateError: `Impossibile aggiornare.`,
    noLinkCopy: `Nessun link da copiare.`,
    linkCopied: `Link copiato.`,
    copyError: `Impossibile copiare il link.`,
    noLinkOpen: `Nessun link da aprire.`,
  },

  commonAreaImages: {
    intro: `Foto generali (ingresso, piscina, reception, giardino…) mostrate all’ospite come copertina quando apre il motore, insieme alla galleria di ogni unità.`,
    imagesCount: `{count} immagine | {count} immagini`,
    reorderHint: `Trascina per riordinare · la principale è la copertina`,
    reordering: `Riordino…`,
    dragTitle: `Trascina`,
    coverBadge: `Copertina`,
    empty: `Non hai ancora aggiunto foto delle aree comuni. Caricale qui sopra per creare la copertina dell’alloggio.`,
    loadError: `Impossibile caricare le foto delle aree comuni.`,
    uploadSuccess: `Foto caricate con successo.`,
    uploadError: `Impossibile caricare le immagini.`,
    orderUpdated: `Ordine aggiornato.`,
    orderError: `Impossibile aggiornare l’ordine.`,
    deleteConfirmMsg: `Eliminare questa foto delle aree comuni?`,
    deleteConfirmHeader: `Elimina immagine`,
    deleteAccept: `Elimina`,
    deleteReject: `Annulla`,
    imageDeleted: `Immagine eliminata.`,
    deleteError: `Impossibile eliminare l’immagine.`,
    coverUpdated: `Copertina aggiornata.`,
    coverError: `Impossibile impostare la copertina.`,
    invalidFiles: `File non validi: {message}\n{details}`,
  },
};
